import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PlaceAutocomplete from '../components/PlaceAutocomplete';
import useAddressStore from '../state/useAddressStore';


const conditions =[
  'Needs total repair',
  'Fair condition',
  'Newly Renovated'
]


export default function GetOffer() {
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    lotsize: '',
    roofage: '',
    price: '',
    beds: '',
    baths: '',
    sqft: '',
    mechanicalCondition: '',
    electricalCondition: '',
    timeline: '',
    propertyDescription: '',
    repairsNeeded: '',
    motivation: '',
    privacyPolicy: false,
  });
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files || []).map((file) => {
      // add a preview URL for images so we can show thumbnails
      if (file.type.startsWith('image/')) {
        file.preview = URL.createObjectURL(file)
      } else {
        file.preview = null
      }
      return file
    })
    // revoke previous previews to avoid memory leaks (cleanup happens in effect too)
    setFiles(selected)
  }

  useEffect(() => {
    return () => {
      files.forEach((f) => {
        if (f.preview) URL.revokeObjectURL(f.preview)
      })
    }
  }, [files])

  // sync global address into the form when available
  const globalAddress = useAddressStore((s) => s.address);
  const setGlobalAddress = useAddressStore((s) => s.setAddress);

  useEffect(() => {
    if (globalAddress && !formData.address) {
      setFormData((p) => ({ ...p, address: globalAddress }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalAddress]);

  const validateForm = () => {
    if (!formData.name.trim()) {
      setError('Name is required');
      return false;
    }
    if (!formData.email.trim()) {
      setError('Email is required');
      return false;
    }
    if (!formData.phone.trim()) {
      setError('Phone is required');
      return false;
    }
    if (!formData.address.trim()) {
      setError('Address is required');
      return false;
    }
    if (!formData.privacyPolicy) {
      setError('Please accept the privacy policy');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const submitData = new FormData();

      // Append all form fields (skip empty strings and null, but include false for privacyPolicy)
      Object.keys(formData).forEach(key => {
        const value = formData[key];
        if (value !== '' && value !== null && value !== undefined) {
          // For privacyPolicy, send as string 'true' or 'false'
          if (key === 'privacyPolicy') {
            submitData.append(key, value ? 'true' : 'false');
          } else {
            submitData.append(key, value);
          }
        }
      });

      // Append files
      files.forEach((file) => {
        submitData.append('files', file);
      });

      // Send POST request to the property API endpoint
      const response = await axios.post('http://127.0.0.1:5000/api/property', submitData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      });

      if (response.status === 200 || response.status === 201) {
        console.log('Property submitted successfully', response.data);
        setSuccess(true);
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          address: '',
          lotsize: '',
          roofage: '',
          price: '',
          beds: '',
          baths: '',
          sqft: '',
          mechanicalCondition: '',
          electricalCondition: '',
          timeline: '',
          propertyDescription: '',
          repairsNeeded: '',
          motivation: '',
          privacyPolicy: false,
        });
        setFiles([]);
        // Reset file input
        const fileInput = document.getElementById('fileInput');
        if (fileInput) fileInput.value = '';
        
        // Scroll to top to show success message
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } catch (err) {
      console.error('Error submitting property:', err);
      const errorMessage = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.message || 
                          'Failed to submit property. Please try again.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className='bg-[#E9E7F4] min-h-screen flex justify-center px-[20px] md:px-[40px]'>
    <div className='flex space-x-[32px] py-[124px] max-w-[1300px]'>
        <div className='w-full'>
            <div className='bg-[#03002F] rounded-t-[32px] px-[30px] md:px-[100px] pt-[35px] pb-[53px]'>
            <h4 className='font-bold text-[24px] md:text-[40px] leading-[50px] text-[#F2F2F2] mb-[10px] font-cabinet'>
                Enter your details
            </h4>
            <p className='text-white text-[12px] md:text-[16px] font-satoshi font-bold'>
                You fill the form below with your personal information and attach pictures of the properties.
            </p>
            </div>
        <div className='bg-white rounded-b-[32px] px-[18px] py-[30px] md:p-[100px]'>
          {/* Error Message */}
          {error && (
            <div className='mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-[8px] text-sm font-satoshi'>
              {error}
            </div>
          )}

          {/* Success Message */}
          {success && (
            <div className='mb-4 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-[8px] text-sm font-satoshi font-bold'>
              Property submitted successfully! We will contact you soon.
            </div>
          )}

          <form className='md:space-y-[35px]' onSubmit={handleSubmit}>
            {/* NAME AND EMAIL ROW */}
            <div className='md:flex md:space-x-[20px]'>
              <div className='w-full md:w-1/2'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder='Name'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
              <div className='w-full md:w-1/2'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder='Email'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
            </div>
            {/* ADDRESS AND PHONE ROW */}
            <div className='md:flex md:space-x-[20px]'>
              <div className='w-full md:w-1/2'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                    <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Address</label>
                    <PlaceAutocomplete
                      value={formData.address}
                      onChange={(addr) => {
                        setFormData((p) => ({ ...p, address: addr }));
                        setGlobalAddress(addr);
                      }}
                      placeholder='Address'
                      name='address'
                      disabled={loading}
                    />
                  </div>
              </div>
              <div className='w-full md:w-1/2'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder='Phone'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
            </div>
            {/* LOT SIZE AND AGE OF ROOF ROW */}
            <div className='md:flex md:space-x-[20px]'>
              <div className='w-full md:w-1/2'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Lot Size</label>
                  <input
                    type="text"
                    name="lotsize"
                    value={formData.lotsize}
                    onChange={handleInputChange}
                    placeholder='Lot Size'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
              <div className='w-full md:w-1/2'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Age of Roof</label>
                  <input
                    type="text"
                    name="roofage"
                    value={formData.roofage}
                    onChange={handleInputChange}
                    placeholder='Age of Roof'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
            </div>
            {/* PRICE AND MEDIA ROW */}
              <div className='md:flex md:space-x-[20px]'>
                <div className='w-full md:w-1/2'>
                  <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                    <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Price</label>
                    <input
                      type="text"
                      name="price"
                      value={formData.price}
                      onChange={handleInputChange}
                      placeholder='Price'
                      disabled={loading}
                      className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                    />
                  </div>
                </div>
                <div className='w-full md:w-1/2'>
                  <div className='flex flex-col w-full mt-[31px]'>
                    <label htmlFor="fileInput" className='rounded-[8px] max-w-max bg-[#282727] text-[#F2F2F2] font-satoshi text-[14px] font-bold py-[19px] px-[34px]'>
    
                      Choose Pictures/Videos
                    </label>
                    <input
                      type="file"
                      id="fileInput"
                      multiple
                      accept="image/*, video/*"
                      className='hidden'
                      onChange={handleFileChange}
                      disabled={loading}
                    />
                  </div>
                </div>

                {/* show selected files */}
                {files.length > 0 && (
                  <div className='w-full mt-4'>
                    <div className='text-sm font-bold mb-2'>Selected media</div>
                    <div className='grid grid-cols-3 gap-3'>
                      {files.map((f, idx) => (
                        <div key={idx} className='border rounded p-2 bg-[#F8F8F8]'>
                          {f.preview ? (
                            <img src={f.preview} alt={f.name} className='w-full h-24 object-cover rounded' />
                          ) : (
                            <div className='text-xs'>{f.name}</div>
                          )}
                          <div className='text-xs mt-2 break-words'>{f.name}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            {/* NUMBER OF BEDS, BATHS, AND SQFT ROW */}
            <div className='md:flex md:space-x-[20px]'>
              <div className='w-full md:w-1/3'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Number of Beds</label>
                  <input
                    type="number"
                    name="beds"
                    value={formData.beds}
                    onChange={handleInputChange}
                    placeholder='Number of Beds'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
              <div className='w-full md:w-1/3'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Number of Baths</label>
                  <input
                    type="number"
                    name="baths"
                    value={formData.baths}
                    onChange={handleInputChange}
                    placeholder='Number of Baths'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
              <div className='w-full md:w-1/3'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Sqft</label>
                  <input
                    type="number"
                    name="sqft"
                    value={formData.sqft}
                    onChange={handleInputChange}
                    placeholder='Sqft'
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  />
                </div>
              </div>
            </div>
            {/* MECHANICAL CONDITIONS AND ELECTRICAL CONDITIONS ROW */}
            <div className='md:flex md:space-x-[20px]'>
              <div className='w-full md:w-1/3'>
                  <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                    <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>
                      Mechanical Conditions
                    </label>
                    <select
                      name="mechanicalCondition"
                      value={formData.mechanicalCondition}
                      onChange={handleInputChange}
                      disabled={loading}
                      className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                    >
                      <option value=''>Select Mechanical Condition</option>
                      {conditions.map((condition, index) => (
                        <option key={index} value={condition}>
                          {condition}
                        </option>
                      ))}
                    </select>
                </div>
              </div>
              <div className='w-full md:w-1/3'>
                  <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                    <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>
                      Electrical Conditions
                    </label>
                    <select
                      name="electricalCondition"
                      value={formData.electricalCondition}
                      onChange={handleInputChange}
                      disabled={loading}
                      className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                    >
                      <option value=''>Select Electrical Condition</option>
                      {conditions.map((condition, index) => (
                        <option key={index} value={condition}>
                          {condition}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              <div className='w-full md:w-1/3'>
                <div className='flex flex-col mb-[16px] md:mb-[0px]'>
                  <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Timeline</label>
                  <select
                    name="timeline"
                    value={formData.timeline}
                    onChange={handleInputChange}
                    disabled={loading}
                    className='rounded-[8px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] h-[57px] bg-[#E3E3E3]'
                  >
                    <option value=''>Select Timeline</option>
                    {[...Array(8).keys()].map((week) => (
                      <option key={week} value={week + 1}>
                        {week + 1} {week === 0 ? 'week' : 'weeks'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* PROPERTY DESCRIPTION ROW */}
            <div className='flex flex-col mb-[16px] md:mb-[0px]'>
              <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Property Description</label>
              <textarea
                name="propertyDescription"
                value={formData.propertyDescription}
                onChange={handleInputChange}
                placeholder='Property description'
                disabled={loading}
                className='rounded-[8px] min-h-[143px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] bg-[#E3E3E3]'
              />
            </div>
            {/* REPAIRS NEEDED ROW */}
            <div className='flex flex-col mb-[16px] md:mb-[0px]'>
              <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Repairs Needed</label>
              <textarea
                name="repairsNeeded"
                value={formData.repairsNeeded}
                onChange={handleInputChange}
                placeholder='Repairs Needed'
                disabled={loading}
                className='rounded-[8px] min-h-[143px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] bg-[#E3E3E3]'
              />
            </div>
            {/* MOTIVATION ROW */}
            <div className='flex flex-col mb-[16px] md:mb-[0px]'>
              <label className='font-bold text-[#282727] font-satoshi text-[14px] md:text-[15px] mb-[10px]'>Motivation</label>
              <textarea
                name="motivation"
                value={formData.motivation}
                onChange={handleInputChange}
                placeholder='Motivation'
                disabled={loading}
                className='rounded-[8px] min-h-[143px] border border-[#282727] text-[#282727] font-satoshi text-[12px] font-medium px-[10px] py-[15px] bg-[#E3E3E3]'
              />
            </div>
            <div className='bg-[#F8F3F3] p-[16px] rounded-[8px] my-[42px]'>
  <label className='flex items-center space-x-[10px]'>
    <input 
      type="checkbox" 
      name="privacyPolicy"
      checked={formData.privacyPolicy}
      onChange={handleInputChange}
      disabled={loading}
      className="form-checkbox text-[#CF7B00] text-[10px] md:text-[14px] leading-[14px] md:leading-[20px]" 
    />
    <span className='text-[#CF7B00] text-[10px] md:text-[14px] leading-[14px] md:leading-[20px] font-satoshi font-bold'>
      Moreproperties takes your privacy seriously. We will never share your information with any 3rd party. 
      <span className='text-[#03002F] font-extrabold underline font-satoshi'>
        <Link to="/privacy-policy"> Click Here</Link>
      </span>{' '}
      to view our Privacy Policy. By clicking the button and submitting your information above, you agree and
      consent for Moreproperties to contact you via phone or sms regarding your inquiry on our site.
    </span>
  </label>
</div>

            <button 
              type="submit" 
              disabled={loading}
              className={`bg-[#5F5CF0] w-[182px] rounded-[8px] py-[22px] text-white font-satoshi font-bold transition-colors ${
                loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#4d4bd6]'
              }`}
            >
              {loading ? 'Submitting...' : 'Get Offer'}
            </button>
          </form>
        </div>
      </div>
    </div>
    </div>
  );
}
